import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

/** Transloco scope for the `/virtual-tour` supplier page. */
export function provideTranslocoScopeFactoryVirtualTourPage(): Provider {
  return provideTranslocoScope({
    alias: 'factoryVirtualTourPage',
    loader: i18nLoader,
    scope: 'shared-factory-virtual-tour-page',
  });
}
